<template>
  <div class="alert">
    <div class="row">
      <div class="col-7 align-self-center pr-0">
        You have unsaved data, would you like to save and continue or lose your data?
      </div>
      <div class="col-2 align-self-center p-0" style="margin-left: -15px;">
        <button class="btn" v-on:click="$emit('leaveAndSave')"><u>Save and Continue</u></button>
      </div>
      <div class="col align-self-center p-0">
        <button class="btn" v-on:click="$emit('leaveWithoutSaving')"><u>Continue</u></button>
      </div>
      <div class="justify-content-end align-self-center">
        <div class="col pl-0">
          <span class="closebtn" v-on:click="$emit('closeWarning')">&times;</span> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
  },
  data(){
    return {
    }
  }
}
</script>

<style>

.alert {
  padding: 20px;
  background-color: #f44336;
  color: white;
}

.closebtn {
  color: white;
  font-weight: bold;
  float: right;
  font-size: 24px;
  cursor: pointer;
}

</style>
